"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaOption = _interopRequireDefault(require("./MediaOption"));

var _constants = require("../utils/constants");

var _uuid = require("uuid");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ScrollableList = function ScrollableList(_ref) {
  var media = _ref.media,
      onMediaClicked = _ref.onMediaClicked;
  var imageMedia = media.filter(function (x) {
    return x.type === _constants.FILE_TYPE_IMAGE;
  });
  var pdfMedia = media.filter(function (x) {
    return x.type === _constants.FILE_TYPE_PDF;
  });
  return media && media.length > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: "scrollable-wrapper"
  }, imageMedia.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_MediaOption.default, {
      key: (0, _uuid.v1)(),
      option: x,
      onClick: onMediaClicked
    });
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      minWidth: '10px'
    }
  }), pdfMedia.map(function (x) {
    return /*#__PURE__*/_react.default.createElement(_MediaOption.default, {
      key: (0, _uuid.v1)(),
      option: x
    });
  }));
};

ScrollableList.propTypes = {
  media: _propTypes.default.arrayOf(_propTypes.default.shape({
    fileName: _propTypes.default.string,
    description: _propTypes.default.string,
    type: _propTypes.default.string,
    url: _propTypes.default.string.isRequired
  })),
  onMediaClicked: _propTypes.default.func
};
ScrollableList.defaultProps = {
  media: [],
  onMediaClicked: function onMediaClicked() {}
};
var _default = ScrollableList;
exports.default = _default;